module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "bodymatter",
      "title": "BODYMATTER"
    }
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "pa1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpa1"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_1",
      "title": "1"
    }
  }, [_vm._v("[Movement One]")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1a"
  }, [_c('a', {
    attrs: {
      "href": "#/text/nav#rpa1"
    }
  }, [_vm._v("TWO STORIES")])]), _vm._v(" "), _c('p', {
    staticClass: "epig1"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATIENT")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RUST")])]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_vm._v("Above all, trust in the slow work of God.")]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_vm._v("We are quite naturally impatient in everything")]), _vm._v(" "), _c('p', {
    staticClass: "epig-1"
  }, [_vm._v("to reach the end without delay.")]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_vm._v("We should like to skip the intermediate stages. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_vm._v("And yet it is the law of all progress")]), _vm._v(" "), _c('p', {
    staticClass: "epig-1"
  }, [_vm._v("that it is made by passing through")]), _vm._v(" "), _c('p', {
    staticClass: "epig-1"
  }, [_vm._v("some stages of instability—")]), _vm._v(" "), _c('p', {
    staticClass: "epig-1"
  }, [_vm._v("and that it may take a very long time. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_vm._v("Give Our Lord the benefit of believing")]), _vm._v(" "), _c('p', {
    staticClass: "epig-1"
  }, [_vm._v("that his hand is leading you,")]), _vm._v(" "), _c('p', {
    staticClass: "epig"
  }, [_vm._v("and accept the anxiety of feeling yourself")]), _vm._v(" "), _c('p', {
    staticClass: "epig-1"
  }, [_vm._v("in suspense and incomplete."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/text/9780718094966_Notes#cp1_rfn1",
      "id": "cp1_fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("—P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IERRE")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EILHARD DE")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HARDIN")]), _vm._v(", S.J.")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('i', [_vm._v("H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EARTS ON")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IRE")]), _vm._v(": P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAYING WITH")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESUITS")])])]), _vm._v(" "), _c('p', {
    staticClass: "h1b"
  }, [_vm._v("WHAT YOU WILL NEED FOR THE EXERCISES")]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("Life Scroll (in the Toolbox in the back of the book)")])]), _vm._v(" "), _c('p', {
    staticClass: "blist"
  }, [_vm._v("•"), _c('span', {
    staticClass: "space"
  }, [_c('span', {
    staticClass: "hide1"
  }), _vm._v("A fine-point permanent marker")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0071faaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780718094966_Part_1.vue
// module id = 81
// module chunks = 0